export const NEW_CLIENTS = 'new-clients';
export const NEW_CLIENTS_LABEL = 'Клиенты (Новый)';
export const NEW_CLIENTS_PATH = `/${NEW_CLIENTS}`;
